import formatDate from '~/helpers/formatDate';
import useTranslation from '~/hooks/useTranslation';
import summaryMainBookerStyles from '~/styles/bookingFlow/summary-main-booker.module.css';
import { PackageInformationRequest } from '~/types/api';

type Props = {
  mainBooker: PackageInformationRequest['main_booker'];
  mainBookerParticipant: PackageInformationRequest['participants'][0];
};

export default function SummaryMainBooker({
  mainBooker,
  mainBookerParticipant,
}: Props) {
  const translate = useTranslation();

  return (
    <>
      <h2 className={summaryMainBookerStyles.heading}>
        {translate('bookingFlow.summary.main_booker_title')}
      </h2>

      <ul className={summaryMainBookerStyles.list}>
        {mainBookerParticipant?.first_name && mainBookerParticipant?.last_name && (
          <li>
            {`${translate('form.name')}: ${mainBookerParticipant?.first_name} ${mainBookerParticipant?.last_name}`}
          </li>
        )}
        {mainBookerParticipant?.birth_date && (
          <li>
            {`${translate('form.birth_date')}: ${formatDate(mainBookerParticipant?.birth_date, 'd-m-Y')}`}
          </li>
        )}

        {mainBooker?.email && (
          <li>
            {`${translate('form.email')}: ${mainBooker?.email}`}
          </li>
        )}
        {mainBooker?.phone && (
          <li>
            {`${translate('form.phone')}: ${mainBooker?.phone_country_code}-${mainBooker?.phone}`}
          </li>
        )}
        {mainBooker?.phone_trip && (
          <li>
            {`${translate('form.phone_trip')}: ${mainBooker?.phone_trip_country_code}-${mainBooker?.phone_trip}`}
          </li>
        )}
      </ul>
    </>
  );
}
